import * as React from "react";
import { SVGProps } from "react";
function SvgListIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 18h12v-2H8v2Zm0-5h12v-2H8v2Zm0-7h12v2H8V6ZM4 18v-2h2v2H4Zm0-5v-2h2v2H4Zm0-7h2v2H4V6Z"
        fill="#fff"
      />
    </svg>
  );
}
export default SvgListIcon;
